'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('ibf', ['ui.router', 'ngCookies', 'ngAlertify', 'ui.bootstrap', 'selectize', 'color.picker', 'angularFileUpload', 'infinite-scroll', 'ngAnimate', 'ui.mask', 'ngYoutubeEmbed', 'ngFileSaver', 'ngSanitize', 'ngCsv', 'ngImageCompress', 'chart.js']).config(['$provide', function ($provide) {

  $provide.decorator('$exceptionHandler', ['$delegate', '$window', function ($delegate, $window) {
    return function (exception, cause) {
      if ($window.trackJs) {
        // Track error and log anything else of interest.
        $window.trackJs.track(exception);
      }

      // In *non-production* environments you may still want the error sent to the console.
      // You can delegate to the original handler (console.error) if you'd like.
      // Warning, this can cause double tracking of errors, so do not use in production.
      $delegate(exception, cause);
    };
  }]);
}]).filter('objectFilter', function () {

  var tmp = function tmp(obj, term, fields) {

    for (var key in obj) {

      if (obj.hasOwnProperty(key)) {

        if (!fields[key]) {
          continue;
        }

        if (_typeof(obj[key]) === 'object' && !Array.isArray(obj[key]) && obj[key] !== null && tmp(obj[key], term, fields[key])) {
          return true;
        } else if (('' + obj[key]).toLowerCase().indexOf(term.toLowerCase()) != -1) {
          return true;
        }
      }
    }

    return false;
  };
  return function (objects, terms, fields) {
    var filtered = [];

    if (!objects) {
      return filtered;
    }

    if (!terms || terms.length < 1) {
      return filtered.concat(objects);
    }

    var termArray = terms.split(' ');

    var valid_fields = {};

    fields.forEach(function (value) {

      if (value.indexOf('.')) {
        var _tmp = value.split('.');
        valid_fields[_tmp[0]] = {};

        // we support until 2 nested levels
        if (_tmp.length > 2) {
          valid_fields[_tmp[0]][_tmp[1]] = {};
          valid_fields[_tmp[0]][_tmp[1]][_tmp[2]] = true;
        } else {
          valid_fields[_tmp[0]][_tmp[1]] = true;
        }
      } else {
        valid_fields[value] = true;
      }
    });

    objects.forEach(function (obj) {
      var found = true;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = termArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var term = _step.value;


          if (!found) {
            break;
          }

          found = tmp(obj, term, valid_fields);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (found) {
        filtered.push(obj);
      }
    });

    return filtered;
  };
}).filter('claimImage', ['environment', function (environment) {
  // Claim images are presigned S3 URLs signed with
  // response-content-disposition=attachment, so the browser downloads them
  // instead of rendering. This proxy re-serves them without that header
  // (and converts HEIC to JPEG).
  return function (url) {
    if (!url || !environment.imageProxyUrl) {
      return url;
    }
    return environment.imageProxyUrl + '?url=' + encodeURIComponent(url);
  };
}]).value('selectizeConfig', {
  create: false,
  highlight: true,
  delimiter: '|',
  maxItems: 1
}).run(['$rootScope', '$location', '$window', 'commonSrv', 'sessionSrv', '$state', 'environment', function ($rootScope, $location, $window, commonSrv, sessionSrv, $state, environment) {
  commonSrv.setStripe($window.Stripe(environment.stripeKey));
  $rootScope.$on('$stateChangeStart', function (event, toState) {
    if ($window.ga) {
      $window.ga('send', 'pageview', { page: $location.path() });
    }
    if (toState.name !== 'validate' && toState.name !== 'login') {
      sessionSrv.redirectUrl = toState.name;
    }
    if (!Object.keys(sessionSrv.user).length) {
      event.preventDefault();
      sessionSrv.user = { redirecting: true };
      $state.go('validate');
    }
  });
}]);
//# sourceMappingURL=app.js.map

'use strict';

(function (angular) {
  angular.module('ibf').config(['$stateProvider', '$urlRouterProvider', '$locationProvider', Appconfig]).config(['$qProvider', function ($qProvider) {
    $qProvider.errorOnUnhandledRejections(window.location.host.indexOf('localhost') >= 0);
  }]);

  function Appconfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(false).hashPrefix('');
    $urlRouterProvider.otherwise('/');

    $stateProvider.state('login', {
      url: '/login',
      templateUrl: 'views/login.html' + '?' + $.now(),
      controller: 'loginCtrl',
      controllerAs: 'log',
      params: {
        redirect: null

      }
    }).state('validate', {
      url: '/validate',
      templateUrl: 'views/validate.html' + '?' + $.now(),
      controller: 'validateCtrl',
      controllerAs: 'validate'
    });
  }
})(angular);
//# sourceMappingURL=config.js.map

angular.module("ibf")
.constant("environment", {
  "appKey": "162290b2-6ef6-11e6-8b77-86f30ca893d3",
  "adminToken": "632e85d9-dbeb-4130-8df1-c2f20557235a",
  "dummyCustomer": "ad36d381-9862-4cbc-9ad2-ddbe0828666f",
  "api": "https://app.ibuyflowers.com/api",
  "baseUrl": "https://app.ibuyflowers.com/#/",
  "v2Url": "https://app.ibuyflowers.com/admin/",
  "imageProxyUrl": "https://app.ibuyflowers.com/api/api_ibf/images/proxy",
  "loginRedirect": "https://app.ibuyflowers.com/shopping/home",
  "growerLogoutRedirect": "https://www.ibuyflowers.com/logged-out-grower/",
  "versionApp": "3.9.0-1909_admin",
  "stripeKey": "pk_live_r0TsAGPh3HvaMdrxKOHfYDTR",
  "label": "prod",
  "domain": 129,
  "production": true,
  "publicPath": "https://sbxcloud.com/www/ibuyflowers",
  "publicPathV3": "https://sbxcloud.com/www/ibuyflowers/",
  "seasons_images_folder_name": "prod/Assets/Images/Seasons/",
  "varietyDefaultKey": "c069c20b-5828-47e5-92f2-d655cf4db904",
  "mixpanel": "33bef9612fd0a274f78b0e87b5c9674a",
  "productGroupDefaultObject": {
    "_KEY": "2387f8d8-09c9-4380-bc2e-526efe6676bf",
    "common_name": "Custom Box"
  },
  "country": {
    "CR": "0bc5898c-a858-4890-8982-934e024dc69d",
    "TH": "10f64db7-5cd6-42cd-8949-596c45a2e916",
    "CO": "20b3a7e1-b20f-491e-8240-1647c72a4f5b",
    "US": "23f73d62-3370-42e3-a9d2-2e453cb5cc44",
    "EC": "2e9bd31b-a45b-41e9-a346-808a2e586a77",
    "NL": "3d0b5c85-4e1f-43d9-9b02-808121858b51"
  },
  "cloudscript": {
    "declineOrderRequest": "0ee16ed9-ce53-4972-abca-caaefb7805e8",
    "addOrderReqBid": "194ca75c-b495-424c-9de1-3b9cf145496f",
    "getOrderReqItemByGrower": "d9b48531-19f3-4072-86d3-eb707a6f9d8c",
    "getHistoryByGrower": "e922641e-2884-4e21-8478-5a2ecf22d34e",
    "removeOrderReqBid": "b81c480c-80a8-4402-8743-a60de02668de",
    "buildFilterTree": "116855D0-C615-461E-B5B5-3C9283A3103D",
    "getBalancePerMonth": "0b43e56f-0b48-4e2c-934b-09622216346b",
    "getGrowerState": "31926e14-3005-458d-8c18-d0dd9781b3cc",
    "getFlowerList": "F673965B-B351-4A7A-862D-45E831CA6607",
    "getGrowShip": "C1ADEE01-7720-4CF9-AB53-6EA7035AB4D7",
    "orderGenerator": "EACA4FA6-C745-4242-9059-936D6A651999",
    "update_cart_box_item_properties": "cc050224-aca3-49cf-a255-53adc4d0105b",
    "dutchGenerator": "62fe6221-2e7a-4124-a099-63a531e51909",
    "searchInventory": "79C729F5-FA1E-4E44-A1B6-0DE7D08F5E89",
    "fetchInventory": "A29FF02D-7195-4BCA-8C38-01303DB838B3",
    "getProdByGrower": "54CB917C-CF46-4E0C-B4EF-54E6977E5172",
    "updateMassiveInventory": "173D20DA-677F-4692-9B2C-05E21F29698A",
    "updateInvCeros": "C1265BF4-75E5-4BEB-ADC7-9A7B45ADC285",
    "cancelBorder": "5F3A9125-B7D4-451B-8574-61A7F2E6C3FD",
    "customImage": "84E48B81-35F9-4CED-AEE8-E8C8EA0F71A0",
    "customerGrowerRelation": "97FC1B89-4E64-43DF-9AB0-37153DEC5AA1",
    "growerCountryArrival": "98EDF184-38AE-4B15-8501-75A0DD891AEC",
    "mailCheckout": "7D1EE54F-61DA-42F2-B763-CB9D78EEFA04",
    "getPurchase": "6AC5E73A-FBC8-44C6-8740-D902BAAB4C80",
    "validate": "5A02D90D-6F47-4E1B-9374-73C35E3EB042",
    "inventoryUpdateAssistant": "3d6f1616-1833-45f2-8d3c-8961fbdfb7d4",
    "updateMasterlistInventory": "cf561eeb-d627-4191-8989-6cbc5727244d",
    "messageSlackMassiveInventory": "7d4376f8-59a6-418a-a287-d7682863ab2e",
    "updatePromoEmailTemplate": "067d6b28-7e25-4f3a-a9ec-d24a3823ca2a",
    "salesforceSync": "b346227f-6415-456f-a45f-0b52dbf23115",
    "getMasterListSearch": "01b4d271-88d9-4127-8d89-12249b1ef825",
    "searchSeasonMasterlist": "57a609ed-cbf1-42e4-afb2-02e6d9067884",
    "updateAllMasterlistInventory": "033da409-0111-401d-9c22-82ab3b035a2e",
    "cassandraSearchInv": "686a36b5-0b32-4e51-a44b-43dce574e63c",
    "loadDependencies": "eebdbd5d-2a97-4139-8fc3-9c28fb9198f2",
    "getFromRedisFiltered": "db39989a-7b94-4274-bafc-18ea39203f52",
    "loginAs": "5608e396-d759-471f-bddc-d1fca96fb127",
    "chargeCartboxes": "B021477E-F296-4FD8-9A79-95E5310C4DCB",
    "getEmailChangeRequest": "bd5e7f74-51dc-497b-b136-b36d31f7dd57",
    "updateEmailChangeRequest": "67985fbd-642c-4d41-8919-7152f9a62a35",
    "OrderGeneratorGrouping": "eb7059ab-0c9f-411b-814f-1b96f64de1c0",
    "ibf_getProduct_groupXGrower": "05c6c894-af35-4e82-9340-4775b1634983",
    "loadProductGroupsByGrower": "ac60e7bb-63e5-422e-8bf1-86a4487fbaee",
    "arrivalPerGrower": "98EDF184-38AE-4B15-8501-75A0DD891AEC",
    "ibf_updateMasterListByGrower": "50bfa558-6e4f-48d5-b142-565e7fc8874b",
    "ibf_removeInventoryCart": "fbd18ed9-4844-4dca-863b-b87a3b099bf0",
    "loadAddress": "ff22617e-cf60-4cb9-91cf-69e936fda549",
    "ibf_getClaim": "66f406fe-25ca-43a5-ae95-65863559cccf",
    "weather_forecast": "cdda2018-bcf8-4194-a6e2-cfcd3ddcbe77",
    "deleteMultiplesCartboxes": "5949c4c6-e565-46ee-8470-69723a4e3d29"
  },
  "folderKeys": {
    "grower": "2de84806-89c8-4892-8660-abce9b27fabd",
    "grower_inventories": "4051f71b-8c19-4405-aa53-802ce0e73c31",
    "florist": "66a5c6e7-8a81-49c7-bcdf-b17996c9565c",
    "varieties": "ee280cd9-63ff-4a89-9fe3-51d1f41580d2",
    "product_group": "56b866ac-a58c-437b-a501-6c7209141f84",
    "images": "ebe0a4a1-a40f-4653-a31c-917bbe96baec",
    "season_images": "e38c2512-5380-41ab-a2be-230de3c0f870"
  },
  "templateEmailKey": {
    "grower_purchase": "ef741046-da04-44ab-a376-f7d030f2bafc",
    "customer_purchase": "cc435260-caae-473e-ab89-3e0c5aadf174",
    "sign_up": "3f064a56-1ce0-415a-8072-f40a9d752d59",
    "request_claim_customer": "dbca0fd5-2619-46cf-85ca-d9f51f36076c",
    "request_claim_grower": "2c51095f-d6c7-4ba7-9029-8b913b407c2d",
    "response_claim": "fa35703f-f16a-4dff-869c-8d634aa283af",
    "standing_order_notif": "",
    "password_retrieve": "b98a713a-b765-45d2-aef6-8f00707d3e99",
    "standing_order_response": "",
    "request_auth": "3b325df3-ab49-4da6-ad56-b7799c15f526",
    "move_order_payment": "42b08346-f915-4093-9159-70eaf44a8acb",
    "move_order_supply": "750ac8f1-09ee-478b-970b-7e4a6e42c7e0",
    "move_order_fedex": "f09ee83b-ea74-4a0a-be88-5465373b34ba",
    "move_order_grower_notification": "c094e70a-8bd5-4730-9e6d-d4bb0e887d52",
    "notif_delete": "14a8a227-b7d8-46f4-9ec1-cd071c32963e"
  }
});

'use strict';

(function (angular) {
  angular.module('ibf').config(['$stateProvider', 'environment', adminConfig]);

  function adminConfig($stateProvider, environment) {

    $stateProvider.state('admin', {
      url: '/admin',
      templateUrl: 'views/admin/layout.html?v=' + environment.versionApp,
      controller: 'adminNavCtrl',
      controllerAs: 'nav'
    }).state('admin.dashboard', {
      url: '/dashboard',
      abstract: true,
      templateUrl: 'views/admin/dashboard.html?v=' + environment.versionApp,
      controller: 'adminDashboardCtrl',
      controllerAs: 'obj'
    }).state('admin.dashboard.salesmonth', {
      url: '/salesmonth',
      templateUrl: 'views/admin/dashboard.salesmonth.html?v=' + environment.versionApp,
      controller: 'adminDashboardSalesMonth',
      controllerAs: 'obj'
    }).state('admin.dashboard.monthdate', {
      url: '/monthdate',
      templateUrl: 'views/admin/dashboard.monthdate.html?v=' + environment.versionApp,
      controller: 'adminDashboardMonthDate',
      controllerAs: 'obj'
    }).state('admin.dashboard.weekdate', {
      url: '/weekdate',
      templateUrl: 'views/admin/dashboard.weekdate.html?v=' + environment.versionApp,
      controller: 'adminDashboardWeekDate',
      controllerAs: 'obj'
    }).state('admin.accounting', {
      url: '/accounting',
      abstract: true,
      templateUrl: 'views/admin/accounting.html?v=' + environment.versionApp,
      controller: 'adminAccountingCtrl',
      controllerAs: 'obj'
    }).state('admin.accounting.balance', {
      url: '/balance',
      templateUrl: 'views/admin/accounting.balance.html?v=' + environment.versionApp,
      controller: 'adminBalanceCtrl',
      controllerAs: 'obj'
    }).state('admin.accounting.growers', {
      url: '/growers',
      templateUrl: 'views/admin/accounting.growers.html?v=' + environment.versionApp,
      controller: 'adminGrowerCtrl',
      controllerAs: 'obj'
    }).state('admin.accounting.customers', {
      url: '/customers',
      templateUrl: 'views/admin/accounting.customers.html?v=' + environment.versionApp,
      controller: 'adminCustomersCtrl',
      controllerAs: 'obj'
    }).state('admin.accounting.changeEmail', {
      url: '/changeEmail',
      templateUrl: 'views/admin/accounting.changeEmail.html?v=' + environment.versionApp,
      controller: 'adminChangeEmailCtrl',
      controllerAs: 'obj'
    }).state('admin.products', {
      url: '/product',
      abstract: true,
      templateUrl: 'views/admin/product.html?v=' + environment.versionApp,
      controller: 'adminProductCtrl',
      controllerAs: 'obj'
    }).state('admin.products.variety', {
      url: '/variety',
      templateUrl: 'views/admin/product.variety.html?v=' + environment.versionApp
    }).state('admin.products.color', {
      url: '/color',
      templateUrl: 'views/admin/product.color.html?v=' + environment.versionApp
    }).state('admin.products.group_type', {
      url: '/group_type',
      templateUrl: 'views/admin/product.group-type.html?v=' + environment.versionApp
    }).state('admin.products.product_group', {
      url: '/product_group',
      templateUrl: 'views/admin/product.product-group.html?v=' + environment.versionApp
    }).state('admin.shopping_list', {
      url: '/shopping_list',
      abstract: true,
      templateUrl: 'views/admin/shopping_lists.html?v=' + environment.versionApp,
      controller: 'adminShoppingListCtrl',
      controllerAs: 'obj'
    }).state('admin.shopping_list.shopping_lists', {
      url: '/shopping_lists',
      templateUrl: 'views/admin/shopping_lists.shopping_lists.html?v=' + environment.versionApp,
      controller: 'adminShoppingsListViewCtrl',
      controllerAs: 'obj'
    }).state('admin.shopping_list.products', {
      url: '/products',
      templateUrl: 'views/admin/shopping_lists.products.html?v=' + environment.versionApp,
      controller: 'adminShoppingListProductsCtrl',
      controllerAs: 'obj'
    }).state('admin.products.weekly_inventory', {
      url: '/weekly_inventory',
      templateUrl: 'views/admin/product.weekly_inventory.html?v=' + environment.versionApp
    }).state('admin.products.inventory', {
      url: '/inventory',
      templateUrl: 'views/admin/product.inventory.html?v=' + environment.versionApp
    }).state('admin.products.marketing', {
      url: '/marketing',
      templateUrl: 'views/admin/product.marketing.html?v=' + environment.versionApp
    }).state('admin.products.seasons', {
      url: '/seasons',
      templateUrl: 'views/admin/seasons.html?v=' + environment.versionApp,
      controller: 'adminSeasonCtrl',
      controllerAs: 'obj'
    }).state('admin.products.update_inventory', {
      url: '/update_inventory',
      templateUrl: 'views/admin/product.update_inventory.html?v=' + environment.versionApp,
      controller: 'adminUpdateInventoryCtrl',
      controllerAs: 'obj'
    }).state('admin.purchaseorders', {
      url: '/purchase_orders',
      abstract: true,
      templateUrl: 'views/admin/purchaseorders.html?v=' + environment.versionApp
    }).state('admin.purchaseorders.packing', {
      url: '/packing',
      templateUrl: 'views/admin/purchaseorders.packing.html?v=' + environment.versionApp,
      controller: 'adminPurchasePackingCtrl',
      controllerAs: 'obj'
    }).state('admin.purchaseorders.list', {
      url: '/',
      templateUrl: 'views/admin/purchaseorders.list.html?v=' + environment.versionApp,
      controller: 'adminPurchaseListCtrl',
      controllerAs: 'obj'
    }).state('admin.purchaseorders.detail', {
      url: '/:purchaseId',
      views: {
        '@admin': {
          templateUrl: 'views/admin/purchaseorders.detail.html?v=' + environment.versionApp,
          controller: 'adminPurchaseDetailCtrl',
          controllerAs: 'obj'
        }
      }
    }).state('admin.pending_auto_buys', {
      url: '/pending_auto_buys',
      templateUrl: 'views/admin/pending_auto_buys.html?v=' + environment.versionApp,
      controller: 'adminPendingAutoBuysCtrl',
      controllerAs: 'obj'
    }).state('admin.standing_orders', {
      url: '/standing_orders',
      templateUrl: 'views/admin/standing_orders.html?v=' + environment.versionApp,
      controller: 'adminStandingOrdersCtrl',
      controllerAs: 'obj'
    }).state('admin.standing_order_price_status', {
      url: '/standing-order-price-status',
      templateUrl: 'views/country/standing-order-price-status.html?v=' + environment.versionApp,
      controller: 'countryStandingOrderPriceStatusCtrl',
      controllerAs: 'obj'
    }).state('admin.claims', {
      url: '/claims',
      abstract: true,
      templateUrl: 'views/admin/claims.html?v=' + environment.versionApp,
      controller: 'adminClaimsCtrl',
      controllerAs: 'obj'
    }).state('admin.claims.pending', {
      url: '/pending_claims',
      templateUrl: 'views/admin/pending_claims.html?v=' + environment.versionApp,
      controller: 'adminPendingClaimsCtrl',
      controllerAs: 'obj'
    }).state('admin.claims.accepted', {
      url: '/accepted',
      templateUrl: 'views/admin/accepted_claims.html?v=' + environment.versionApp,
      controller: 'adminAcceptedClaimsCtrl',
      controllerAs: 'obj'
    }).state('admin.claims.rejected', {
      url: '/rejected',
      templateUrl: 'views/admin/rejected_claims.html?v=' + environment.versionApp,
      controller: 'adminRejectedClaimsCtrl',
      controllerAs: 'obj'
    }).state('admin.claims.void', {
      url: '/void',
      templateUrl: 'views/admin/void_claims.html?v=' + environment.versionApp,
      controller: 'adminVoidClaimsCtrl',
      controllerAs: 'obj'
    }).state('admin.boxes', {
      url: '/boxes',
      abstract: true,
      templateUrl: 'views/admin/boxes.html?v=' + environment.versionApp,
      controller: 'boxesTabsCtrl',
      controllerAs: 'box'
    }).state('admin.boxes.boxes', {
      url: '/',
      templateUrl: 'views/admin/manage-boxes.html?v=' + environment.versionApp
    }).state('admin.boxes.dim_factor', {
      url: '/dim_factor',
      templateUrl: 'views/admin/dim-factor.html?v=' + environment.versionApp
    }).state('admin.boxes.freight_cost', {
      url: '/freight_cost',
      templateUrl: 'views/admin/freight-cost.html?v=' + environment.versionApp
    }).state('admin.boxes.holiday_tag', {
      url: '/holiday_tag',
      templateUrl: 'views/admin/holiday-tag.html?v=' + environment.versionApp
    }).state('admin.boxes.banner_upload', {
      url: '/banner_upload',
      templateUrl: 'views/admin/banner-upload.html?v=' + environment.versionApp
    }).state('admin.add_grower', {
      url: '/add_grower',
      templateUrl: 'views/admin/add-grower.html?v=' + environment.versionApp,
      controller: 'adminManageGrowerCtrl',
      controllerAs: 'modal',
      params: {
        grower: null,
        user: null
      }
    });
  }
})(angular);
//# sourceMappingURL=adminState.js.map

'use strict';

(function (angular) {
  angular.module('ibf').config(['$stateProvider', 'environment', adminConfig]);

  function adminConfig($stateProvider, environment) {

    $stateProvider.state('country', {
      url: '/countrymanager',
      templateUrl: 'views/country/layout.html?v=' + environment.versionApp,
      controller: 'countryNavCtrl',
      controllerAs: 'nav'
    }).state('country.purchaseorders', {
      url: '/packinglist',
      templateUrl: 'views/admin/purchaseorders.packing.html?v=' + environment.versionApp,
      controller: 'adminPurchasePackingCtrl',
      controllerAs: 'obj'
    }).state('country.products', {
      url: '/products',
      abstract: true,
      templateUrl: 'views/country/product.html?v=' + environment.versionApp,
      controller: 'countryProductCtrl',
      controllerAs: 'obj'
    }).state('country.products.variety', {
      url: '/variety',
      templateUrl: 'views/admin/product.variety.html?v=' + environment.versionApp
    }).state('country.products.color', {
      url: '/color',
      templateUrl: 'views/admin/product.color.html?v=' + environment.versionApp
    }).state('country.products.group_type', {
      url: '/group_type',
      templateUrl: 'views/admin/product.group-type.html?v=' + environment.versionApp
    }).state('country.products.product_group', {
      url: '/product_group',
      templateUrl: 'views/admin/product.product-group.html?v=' + environment.versionApp
    }).state('country.products.weekly_inventory', {
      url: '/weekly_inventory',
      templateUrl: 'views/admin/product.weekly_inventory.html?v=' + environment.versionApp
    }).state('country.claims', {
      url: '/claims',
      abstract: true,
      templateUrl: 'views/admin/claims.html?v=' + environment.versionApp,
      controller: 'adminClaimsCtrl',
      controllerAs: 'obj'
    }).state('country.claims.pending', {
      url: '/pending_claims',
      templateUrl: 'views/admin/pending_claims.html?v=' + environment.versionApp,
      controller: 'adminPendingClaimsCtrl',
      controllerAs: 'obj'
    }).state('country.claims.accepted', {
      url: '/accepted',
      templateUrl: 'views/admin/accepted_claims.html?v=' + environment.versionApp,
      controller: 'adminAcceptedClaimsCtrl',
      controllerAs: 'obj'
    }).state('country.claims.rejected', {
      url: '/rejected',
      templateUrl: 'views/admin/rejected_claims.html?v=' + environment.versionApp,
      controller: 'adminRejectedClaimsCtrl',
      controllerAs: 'obj'
    }).state('country.claims.void', {
      url: '/void',
      templateUrl: 'views/admin/void_claims.html?v=' + environment.versionApp,
      controller: 'adminVoidClaimsCtrl',
      controllerAs: 'obj'
    }).state('country.accounting', {
      url: '/balance',
      templateUrl: 'views/admin/accounting.balance.html?v=' + environment.versionApp,
      controller: 'adminBalanceCtrl',
      controllerAs: 'obj'
    }).state('country.masterlist', {
      url: '/masterlist/:growerId',
      templateUrl: 'views/grower/setup.masterlist.view.html?v=' + environment.versionApp,
      controller: 'growerSetupCtrl',
      controllerAs: 'obj',
      params: {
        imageData: null
      }
    }).state('country.grower', {
      url: '/grower',
      templateUrl: 'views/country/grower.html?v=' + environment.versionApp,
      controller: 'countryProductCtrl',
      controllerAs: 'obj'
    }).state('country.standing_order_price_status', {
      url: '/standing-order-price-status',
      templateUrl: 'views/country/standing-order-price-status.html?v=' + environment.versionApp,
      controller: 'countryStandingOrderPriceStatusCtrl',
      controllerAs: 'obj'
    }).state('country.inventory', {
      url: '/inventory',
      templateUrl: 'views/admin/inventory_tabs.html?v=' + environment.versionApp,
      controller: 'adminInventoryCtrl',
      controllerAs: 'obj'
    }).state('country.inventory.delete_inventory', {
      url: '/delete_inventory',
      templateUrl: 'views/admin/inventory.html?v=' + environment.versionApp,
      controller: 'adminInventoryCtrl',
      controllerAs: 'obj'
    }).state('country.inventory.delete_multiple_inventory', {
      url: '/delete_multiple_inventory',
      templateUrl: 'views/admin/inventory_delete_multiple.html?v=' + environment.versionApp,
      controller: 'adminDeleteMultipleInventoryCtrl',
      controllerAs: 'obj'
    });
  }
})(angular);
//# sourceMappingURL=countryState.js.map

'use strict';

(function (angular) {
  angular.module('ibf').config(['$stateProvider', 'environment', growerConfig]);

  function growerConfig($stateProvider, environment) {
    $stateProvider.state('grower', {
      url: '/grower',
      templateUrl: 'views/grower/layout.html?v=' + environment.versionApp,
      controller: 'growerNavCtrl',
      controllerAs: 'nav'
    }).state('grower.dashboard', {
      url: '/dashboard',
      templateUrl: 'views/grower/dashboard.html?v=' + environment.versionApp,
      controller: 'growerDashboardCtrl',
      controllerAs: 'obj'
    }).state('grower.purchase_order_detail', {
      url: '/purchase_order_detail/:purchaseId',
      templateUrl: 'views/grower/purchase.detail.html?v=' + environment.versionApp,
      controller: 'growerPurchaseDetailCtrl',
      controllerAs: 'obj'
    }).state('grower.orders', {
      url: '/orders',
      templateUrl: 'views/grower/orders.html?v=' + environment.versionApp,
      controller: 'growerOrdersCtrl',
      abstract: true,
      controllerAs: 'obj'
    }).state('grower.orders.list', {
      url: '/list',
      templateUrl: 'views/grower/orders.list.html?v=' + environment.versionApp,
      controller: 'growerOrdersListCtrl',
      controllerAs: 'obj'
    }).state('grower.orders.cancelled', {
      url: '/cancelled',
      templateUrl: 'views/grower/orders.cancelled.html?v=' + environment.versionApp,
      controller: 'growerOrdersCancelledCtrl',
      controllerAs: 'obj'
    }).state('grower.order_request', {
      url: '/order_request',
      templateUrl: 'views/grower/order_request.html?v=' + environment.versionApp,
      controller: 'growerOrderRequestCtrl',
      abstract: true,
      controllerAs: 'obj'
    }).state('grower.order_request.open', {
      url: '/open',
      templateUrl: 'views/grower/order_request.open.html?v=' + environment.versionApp,
      controller: 'growerOrderRequestOpenCtrl',
      controllerAs: 'obj'
    }).state('grower.order_request.history', {
      url: '/history',
      templateUrl: 'views/grower/order_request.history.html?v=' + environment.versionApp,
      controller: 'growerOrderRequestHistoryCtrl',
      controllerAs: 'obj'
    }).state('grower.accounting', {
      url: '/accounting',
      templateUrl: 'views/grower/accounting.html?v=' + environment.versionApp,
      controller: 'growerAccountingCtrl',
      controllerAs: 'obj'
    }).state('grower.inventory', {
      url: '/inventory',
      abstract: true,
      templateUrl: 'views/grower/inventory.html?v=' + environment.versionApp,
      controller: 'growerInventoryCtrl',
      controllerAs: 'content'
    }).state('grower.inventory.viewer', {
      url: '/viewer',
      templateUrl: 'views/grower/inventory.viewer.html?v=' + environment.versionApp,
      controller: 'growerInventoryViewerCtrl',
      controllerAs: 'obj'
    }).state('grower.inventory.update_assistant', {
      url: '/update_assistant',
      templateUrl: 'views/grower/inventory.update-assistant.html?v=' + environment.versionApp,
      controller: 'growerInventoryUpdateAssistantCtrl',
      controllerAs: 'obj'
    }).state('grower.inventory.import_assistant', {
      url: '/import_assistant',
      templateUrl: 'views/grower/inventory.import-assistant.html?v=' + environment.versionApp,
      controller: 'growerInventoryImportAssistantCtrl',
      controllerAs: 'obj'
    }).state('grower.inventory.recommendation', {
      url: '/recommendation',
      templateUrl: 'views/grower/inventory.recommendation.html?v=' + environment.versionApp,
      controller: 'growerInventoryRecommendationCtrl',
      controllerAs: 'obj'
    }).state('grower.inventory.copy_delete_assistant', {
      url: '/delete_assistant',
      templateUrl: 'views/grower/inventory.copy-delete-assistant.html?v=' + environment.versionApp,
      controller: 'growerInventoryCopyDelAssistantCtrl',
      controllerAs: 'obj'
    }).state('grower.standingorders', {
      url: '/standing_orders',
      abstract: true,
      templateUrl: 'views/grower/grower.standingorders.html?v=' + environment.versionApp,
      controller: 'growerStandingOrdersCtrl',
      controllerAs: 'content'
    }).state('grower.standingorders.pending', {
      url: '/pending',
      templateUrl: 'views/grower/grower.standingorders.pending.html?v=' + environment.versionApp,
      controller: 'growerStandingOrdersPendingCtrl',
      controllerAs: 'obj'
    }).state('grower.standingorders.confirmed', {
      url: '/confirmed',
      templateUrl: 'views/grower/grower.standingorders.confirmed.html?v=' + environment.versionApp,
      controller: 'growerStandingOrdersConfirmedCtrl',
      controllerAs: 'obj'
    }).state('grower.standingorders.canceled', {
      url: '/canceled',
      templateUrl: 'views/grower/grower.standingorders.canceled.html?v=' + environment.versionApp,
      controller: 'growerStandingOrdersCanceledCtrl',
      controllerAs: 'obj'
    }).state('grower.claims', {
      url: '/claims',
      abstract: true,
      templateUrl: 'views/grower/claim.html?v=' + environment.versionApp,
      controller: 'growerClaimsCtrl',
      controllerAs: 'content'
    }).state('grower.claims.pending', {
      url: '/pending',
      templateUrl: 'views/grower/claim.pending.html?v=' + environment.versionApp,
      abstract: true
    }).state('grower.claims.pending.list', {
      url: '/',
      templateUrl: 'views/grower/claim.pending.list.html?v=' + environment.versionApp,
      controller: 'growerClaimsPendingCtrl',
      controllerAs: 'obj'

    }).state('grower.claims.pending.detail', {
      url: '/detail/:key',
      templateUrl: 'views/grower/claim.detail.html?v=' + environment.versionApp,
      controller: 'growerClaimDetailCtrl',
      controllerAs: 'obj'

    }).state('grower.claims.settled', {
      url: '/settled',
      templateUrl: 'views/grower/claim.settled.html?v=' + environment.versionApp,
      controller: 'growerClaimsSettledCtrl',
      abstract: true
    }).state('grower.claims.settled.list', {
      url: '/',
      templateUrl: 'views/grower/claim.settled.list.html?v=' + environment.versionApp,
      controller: 'growerClaimsSettledCtrl',
      controllerAs: 'obj'
    }).state('grower.claims.settled.detail', {
      url: '/detail/:key',
      templateUrl: 'views/grower/claim.detail.html?v=' + environment.versionApp,
      controller: 'growerClaimSettleDetailCtrl',
      controllerAs: 'obj'
    }).state('grower.setup', {
      abstract: true,
      url: '/setup',
      templateUrl: 'views/grower/setup.html?v=' + environment.versionApp,
      controller: 'growerSetupCtrl',
      controllerAs: 'content'
    }).state('grower.setup.company', {
      url: '/company',
      templateUrl: 'views/grower/setup.company-info.html?v=' + environment.versionApp,
      controller: 'growerSetupCtrl',
      controllerAs: 'obj'
    }).state('grower.setup.users', {
      url: '/users',
      templateUrl: 'views/grower/setup.users.html?v=' + environment.versionApp,
      controller: 'growerSetupCtrl',
      controllerAs: 'obj'
    }).state('grower.setup.bulk-discount', {
      url: '/bulk-discount',
      templateUrl: 'views/grower/setup.bulk-discount.html?v=' + environment.versionApp,
      controller: 'bulkDiscountCtrl',
      controllerAs: 'obj'
    }).state('grower.setup.masterlist', {
      abstract: true,
      url: '/masterlist',
      templateUrl: 'views/grower/setup.masterlist.html?v=' + environment.versionApp
    }).state('grower.setup.masterlist.view', {
      url: '/',
      templateUrl: 'views/grower/setup.masterlist.view.html?v=' + environment.versionApp,
      controller: 'growerSetupCtrl',
      controllerAs: 'obj'
    }).state('grower.setup.masterlist.new', {
      url: '/new',
      templateUrl: 'views/grower/add-masterlist.html?v=' + environment.versionApp,
      controller: 'growerMasterlistAddCtrl',
      controllerAs: 'obj'
    }).state('grower.setup.pictures', {
      url: '/pictures',
      templateUrl: 'views/grower/setup.pictures.html?v=' + environment.versionApp
    }).state('grower.setup.specials', {
      url: '/specials',
      templateUrl: 'views/grower/setup.specials.html?v=' + environment.versionApp,
      controller: 'growerSpecialsCtrl',
      controllerAs: 'obj'
    }).state('grower.setup.customers', {
      url: '/customers',
      templateUrl: 'views/grower/setup.customers.html?v=' + environment.versionApp,
      controller: 'growerCostumersCtrl',
      controllerAs: 'obj'
    }).state('grower.setup.benchmark', {
      url: '/benchmark',
      templateUrl: 'views/grower/setup.benchmark.html?v=' + environment.versionApp,
      controller: 'growerSetupCtrl',
      controllerAs: 'obj'
    }).state('grower.inventory.update_inventory', {
      url: '/inventory_update',
      templateUrl: 'views/admin/inventory.html?v=' + environment.versionApp,
      controller: 'adminInventoryCtrl',
      controllerAs: 'obj'
    }).state('grower.setup.standingorder', {
      url: '/stading_orders',
      templateUrl: 'views/grower/setup-stading-orders.html?v=' + environment.versionApp,
      controller: 'growerSetupStandingOrdersCntrl',
      controllerAs: 'obj'
    });
  }
})(angular);
//# sourceMappingURL=growerState.js.map

'use strict';

(function (angular) {
  angular.module('ibf').config(['$stateProvider', 'environment', landingConfig]);

  function landingConfig($stateProvider, environment) {
    $stateProvider.state('landing', {
      url: '/',
      templateUrl: 'views/landing/landing.html?v=' + environment.versionApp,
      controller: 'landingCtrl',
      controllerAs: 'landing'
    }).state('landing.registered', {
      url: 'registered',
      templateUrl: 'views/landing/landing.registered.html?v=' + environment.versionApp,
      controller: 'landingCtrl',
      controllerAs: 'landing'
    }).state('landing.growers', {
      url: 'our_premium_growers/our-excellent-flower-growers-produce-top-quality-fresh-flowers-for-a-fair-price',
      templateUrl: 'views/landing/landing.premium_growers.html?v=' + environment.versionApp,
      controller: 'landingCtrl',
      controllerAs: 'landing'
    }).state('landing.core_values', {
      url: '9_core_values/buy-longer-lasting-flowers-for-lower-prices-by-the-bunch-helping-society',
      templateUrl: 'views/landing/landing.core_values.html?v=' + environment.versionApp,
      controller: 'landingCtrl',
      controllerAs: 'landing'
    }).state('landing.signup', {
      url: 'signup?sales',
      templateUrl: 'views/landing/landing.signup.html?v=' + environment.versionApp,
      controller: 'landingCtrl',
      controllerAs: 'obj',
      params: {
        sales: null
      }
    });
  }
})(angular);
//# sourceMappingURL=landingState.js.map
